import * as React from 'react';
import { IActions, actionCreator } from '../../common/store/contacts/actions/creators';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IActions as IChatAction, actionCreator as chatActionCreator } from './store/actions/creators';
import { IState } from '../../common/store/contacts/state';
import { IState as IChatState } from './store/state';
import { IState as IAuth0State } from '../../common/Auth0/store/state'
import { Users } from './component/Users';
import { ChatBox } from './component/ChatBox';
import { Grid, withStyles, StyledComponentProps, Tab, Tabs, CircularProgress } from '@material-ui/core';
import { IApplicationState } from '../../store/ApplicationState';
import { connect } from 'react-redux';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { styles } from './styles';
import Filters from './component/Filter/Filters';
import { UserPagination } from './component/UserPagination';
interface Iprops extends IActions, IChatAction, IState, IChatState, IAuth0State, IMediaQueryProps, StyledComponentProps {
    // addMessage: (chatmessage: chatmessage) => void;
    navigateTo: (path: string) => void;
    match: {
        params: {
            id: string
        }
    }
}

interface IInternalState {
    contactsCollapsed: boolean;
    messageContainerHeigth: any;
    selectedTab: string;
    fullnameOrEmail: string;
}


const DefaultRowsPerPage = 10;

class drawLayoutChat extends React.Component<Iprops, IInternalState> {

    messaBoxRef;
    constructor(c, p) {
        super(c, p);
        this.messaBoxRef = React.createRef();
        this.state = {
            contactsCollapsed: false,
            messageContainerHeigth: undefined,
            selectedTab: "recent",
            fullnameOrEmail: "",
        }
    }
    
    componentDidMount() {
        window.addEventListener('resize', this.setMessageContainerStyle);
        this.setMessageContainerStyle();

        const { id } = this.props.match.params;
        // setTimeout(() => SignalRConnection.registerConnectionHandler('SendMessageToAdmin', this.UpdateStoreMessages), 1000);

        if (!id) {
            this.props.loadRecentContacts(DefaultRowsPerPage);
            this.props.loadContactsPaginated(``, ``, 0, DefaultRowsPerPage).then(resp => {
                if (id) {
                    //let user = resp.find(cont => cont._id === this.props.match.params.id);
                    //if (user) {
                    this.props.loadContact(id);
                    this.getAndUpdateMessages(id);
                    //}

                }
            })
        } else if (id) {
            //let user = this.props.contacts.find(cont => cont._id === this.props.match.params.id);
            //if (user) {
            this.handleTabChange("search");
            this.props.loadContact(id);
            this.getAndUpdateMessages(id);
            //}
        }

        this.props.getUnreadCount();
    }

    // componentWillUnmount() {
    //     SignalRConnection.removeConnectionHandler('SendMessageToAdmin');
    // }

    getCurrentUserSub = () => this.props.match.params.id;

    // private UpdateStoreMessages = (message: IChatMessage) => {
    //     this.props.receiveMessageWebSocket(message, this.getCurrentUserSub());
    //     this.props.setChatMessagesAsSeen(this.getCurrentUserSub());
    // }

    getAndUpdateMessages = sub => {
        this.props.setChatMessagesAsSeen(sub);
        this.props.getChatMessages(sub);
    }

    handleUserSelection = (sub: string) => {
        if (this.props.smallScreen)
            this.setState({ contactsCollapsed: true });
        this.props.navigateTo(`/private/Chat/${sub}`)
    }
    toggleCotactsSectionCollapse = () => {
        this.setState({ contactsCollapsed: !this.state.contactsCollapsed });
    }
    setMessageContainerStyle = (ev?: UIEvent) => {
        if (this.messaBoxRef && this.messaBoxRef.current) {
            const windowHeigth = window.innerHeight;
            const heigth = windowHeigth - this.messaBoxRef.current.offsetTop - 40;
            this.setState({ messageContainerHeigth: `${heigth}px` });
        }
    }

    handleTabChange = (tab) => {
        if (tab === "recent" && this.state.selectedTab !== "recent") {
            this.props.loadRecentContacts(DefaultRowsPerPage);
        }
        this.setState({
            selectedTab: tab,
        })
    }

    private handleChangeFullnameOrEmail = (val: string) => {
        this.setState({ fullnameOrEmail: val })
    }

    private search = (page: number, fullnameOrEmail: string) => {
        this.props.loadContactsPaginated(fullnameOrEmail, "", page, DefaultRowsPerPage);
    }

    goToContact = (sub: string) => {
        this.props.navigateTo(`/private/Contacts/${sub}`);
    }

    render() {
        const sub = this.getCurrentUserSub();
        let messages = sub ? this.props.chatmessages.byId[sub] : [];
        const users = this.state.selectedTab === "search" ? this.props.contacts.map(u => { return { ...u } }) : this.props.recentContacts.map(u => { return { ...u } });
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} sm={4}>
                    <Paper title='Contatti'
                        collapsed={this.props.smallScreen ? this.state.contactsCollapsed : undefined}
                        toggleCollapse={this.toggleCotactsSectionCollapse}
                        fullHeight={!this.props.smallScreen}
                        contentContainerStyle={this.props.smallScreen ? { height: '200px', overflow: 'auto' } : {}}
                    >
                        <Tabs variant={"fullWidth"} style={{ width: "100%" }} value={this.state.selectedTab} onChange={(e, tab) => { this.handleTabChange(tab) }} >
                            <Tab value={"recent"} label="Recenti" />
                            <Tab value={"search"} label="Cerca" />
                        </Tabs> {this.props.isLoadingContacts ?
                            <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
                                <CircularProgress size={80} />
                            </Grid>
                            :
                            <>
                                {this.state.selectedTab === "search" &&
                                    <Filters fullnameOrEmail={this.state.fullnameOrEmail}
                                        handleChangeFullnameOrEmail={this.handleChangeFullnameOrEmail}
                                        search={this.search} />}
                                <Users
                                    unreadcount={this.props.unreadcount}
                                    current={sub}
                                    setSelectedUser={sub => this.handleUserSelection(sub)}
                                    contactList={users}
                                    goToContact={this.goToContact}
                                    onContactClick={this.props.loadContact}
                                    getChatMessages={this.getAndUpdateMessages}
                                />
                                {this.state.selectedTab === "search" && <Grid item xs={12}>
                                    <UserPagination next={() => { this.search(this.props.page + 1, this.state.fullnameOrEmail) }}
                                        prev={() => { this.search(this.props.page - 1, this.state.fullnameOrEmail) }}
                                        page={this.props.page}
                                        totalRows={this.props.totalRows} rowsPerPage={DefaultRowsPerPage} />
                                </Grid>}
                            </>}
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={8}>
                    <ChatBox
                        messageBoxRef={this.messaBoxRef}
                        messageContainerHeigth={this.state.messageContainerHeigth}
                        classes={this.props.classes}
                        smallScreen={this.props.smallScreen}
                        contact={this.props.contact}
                        addMessage={this.props.addMessage}
                        chatMessages={messages}
                        profile={this.props.profile}
                    />
                </Grid>
            </Grid>
        )
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.contacts,
    ...state.chatmessages,
    ...state.auth,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        ...actionCreator(dispatch),
        ...chatActionCreator(dispatch),
        navigateTo: authActions(dispatch).navigateTo
    }
};

export const ChatContainer = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles)(drawLayoutChat)));